
export default {
  data() {
    return {};
  },
  props: {
    visible: {//是否可见
      type: Boolean,
      default: false
    },
    multiple: {//允许多选
      type: Boolean,
      default: true
    },
    roleKeys:Array,//角色主键
  },
  methods: {
    cancel(){
      this.$emit('callback', null);
    },
    shClose(){//关闭时激活
      const me = this, picker=me.$refs['role-picker'];
      me.$emit('callback', picker.getRoles());
    },
    close(){
      this.$emit('callback', null);
    },
    initRole(){
      const me = this, picker=me.$refs['role-picker'];
      picker.loadAll();
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/role/dialog/src/dialog.js